import { USER_DIALOG_MESSAGES, UserDialogMessages } from "./user-dialog.messages";
import USER_FORM_MESSAGES, { UserFormMessages } from "./user-form.messages";
import { USER_REQUEST_MESSAGES, UserRequestMessages } from "./user-request-messages";
import { USER_TABLE_MESSAGES, UserTableMessages } from "./user-table.messages";
import { USERS_FILTERS_MESSAGES, UsersFiltersMessages } from "./users-filters.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";

export type UsersMessages = UserFormMessages &
  UsersFiltersMessages &
  ActionButtonMessages &
  SidebarMessages &
  PopoverMessages &
  UserRequestMessages &
  UserTableMessages &
  UserDialogMessages & {
    // Title Messages
    pageTitle: string;
    userBreadCrumbTitle: string;
    createUserPageTitle: string;
    createUserBreadCrumbTitle: string;
    updateUserPageTitle: string;
    updateUserBreadCrumbTitle: string;
    userTableTitle: string;

    // Button Messages
    addUserButton: string;
  };

export const USERS_MESSAGES: UsersMessages = {
  // Title Messages
  pageTitle: "Usuários",
  createUserPageTitle: "Criar usuário",
  updateUserPageTitle: "Editar usuário",
  userTableTitle: "Listagem de Usuários",

  userBreadCrumbTitle: "Usuários",
  createUserBreadCrumbTitle: "Criar usuário",
  updateUserBreadCrumbTitle: "Editar usuário",

  // Button Messages
  addUserButton: "Novo Usuário",

  ...POPOVER_MESSAGES,
  ...USERS_FILTERS_MESSAGES,
  ...USER_REQUEST_MESSAGES,
  ...USER_TABLE_MESSAGES,
  ...USER_DIALOG_MESSAGES,
  ...USER_FORM_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
};

export default USERS_MESSAGES;
